import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { isProfileComplete } from '@/services/profileCompletionService';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        console.log('🔄 AuthCallback: Processando callback do Google OAuth...');
        console.log('🔄 URL atual:', window.location.href);
        console.log('🔄 Hash:', window.location.hash);
        console.log('🔄 Search params:', window.location.search);
        
        // Primeiro tentar processar hash fragments do OAuth (caso existam)
        if (window.location.hash) {
          console.log('🔍 AuthCallback: Hash detectado, aguardando processamento do Supabase...');
          // Aguardar um pouco para o Supabase processar o hash
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
        
        // Obter sessão atual
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('❌ AuthCallback: Erro ao obter sessão:', error);
          navigate('/login');
          return;
        }

        if (data.session && data.session.user) {
          console.log('✅ AuthCallback: Usuário autenticado:', data.session.user.email);
          console.log('📊 AuthCallback: Metadata do usuário:', data.session.user.user_metadata);
          
          const userId = data.session.user.id;
          const isGoogleUser = data.session.user.user_metadata?.iss?.includes('google') || 
                               data.session.user.app_metadata?.providers?.includes('google');
          
          // Se for usuário Google, verificar se o perfil está completo
          if (isGoogleUser) {
            console.log('🔍 AuthCallback: Usuário Google detectado, verificando perfil...');
            
            try {
              const profileComplete = await isProfileComplete(userId);
              
              if (!profileComplete) {
                console.log('⚠️ AuthCallback: Perfil incompleto detectado, AuthProvider mostrará modal');
                // O AuthProvider já vai mostrar o modal automaticamente
              } else {
                console.log('✅ AuthCallback: Perfil completo, pode prosseguir normalmente');
              }
            } catch (error) {
              console.error('❌ AuthCallback: Erro ao verificar perfil:', error);
              // Mesmo com erro, prosseguir - o AuthProvider fará a verificação
            }
          } else {
            console.log('👤 AuthCallback: Usuário de login tradicional');
          }
          
          // Sempre redirecionar para home - o AuthProvider mostrará o modal se necessário
          console.log('🏠 AuthCallback: Redirecionando para home...');
          navigate('/');
        } else {
          console.warn('⚠️ AuthCallback: Nenhuma sessão encontrada após callback');
          navigate('/login');
        }
      } catch (err) {
        console.error('❌ AuthCallback: Erro inesperado:', err);
        navigate('/login');
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0f141c]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#00B6F0] mx-auto"></div>
        <p className="mt-4 text-white">Processando autenticação com Google...</p>
        <p className="mt-2 text-gray-400 text-sm">Aguarde enquanto validamos suas credenciais</p>
      </div>
    </div>
  );
};

export default AuthCallback; 